'use client';

import { usePathname } from 'next/navigation';

export default function Template({ children }: { children: React.ReactNode }) {
  // FIXME: change to using cit context provider to get whether we're in iframe mode once thats added
  const pathname = usePathname();
  const isIframeRoute = pathname?.startsWith('/iframe');

  // if route is an iframe route, don't wrap in layout-container, which adds space at top for nav bar, not needed for iframe
  if (isIframeRoute) {
    return <>{children}</>;
  }

  return <div className='layout-container'>{children}</div>;
}
